import colors from 'assets/theme/base/colors';
import pxToRem from 'assets/theme/function/px-to-rem';
import rgba from 'assets/theme/function/rgba';

const tableCell = {
    defaultProps: {
        //align: 'center' as const,
    },
    styleOverrides: {
        root: {
            fontSize: pxToRem(14),
            fontWeight: 400,
            lineHeight: pxToRem(19.6),
            //border: 'none',
            //borderColor: colors.primary.light,
            padding: `${pxToRem(15)} ${pxToRem(2)}`,
            backgroundColor: colors.secondary.light,
        },

        head: {
            backgroundColor: rgba(colors.action.menu, 1),
            fontSize: pxToRem(16),
            padding: pxToRem(5),
            color: colors.common.white,
            fontWeight: 900,
            borderBottom: 'none',
            /*borderRight: `${borderWidth[1]} solid ${colors.info.focus}`,*/
            ' &&.MuiTableCell-root': {
                textAlign: 'center',
            },
        },

        body: {
            color: colors.common.white,
            '.MuiTableCell-body': {
                textAlign: 'center',
            },
            '&. MuiTableRow-root': {
                '&:hover': {
                    backgroundColor: colors.error.main,
                    cursor: 'pointer',
                },
            },
        },

        /*small: {
            fontSize: pxToRem(10.4),
            textAlign: 'center',
        },

        medium: {
            backgroundColor: '#211',
        },*/
    },
};

export default tableCell;
